'use client';

import { c as _c } from "react/compiler-runtime";
import type { Role } from '@svenskaspelab/nova-core/nextjs/auth';
import { useCouponId, useCouponIndices, useCouponType } from '@svenskaspelab/poolbetting/core/frameworks/nextjs/coupon';
import type { DrawNumber } from '@svenskaspelab/poolbetting/schema/draw';
import type { Definition } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { RetailerBalanceResult } from '@svenskaspelab/poolbetting/schema/marketplace';
import type { ReactNode } from 'react';
import CouponsOverview from './CouponsOverview';
import SrowCouponOverviewContainer from './sRow/SrowCouponOverviewContainer';
type CouponsOverviewContainerProps = {
  drawNumber: DrawNumber;
  product: Definition['drawProducts'][number];
  retailerData?: RetailerBalanceResult;
  role: Role;
};

/**
 * CouponsOverviewContainer component.
 *
 * @param root0 The props object.
 * @param root0.drawNumber The current draw number.
 * @param root0.product The product type.
 * @param root0.retailerData Retailer balance data.
 * @param root0.role Role of the user (e.g., 'Retailer', 'Player').
 * @returns The coupons overview component.
 */
export default function CouponsOverviewContainer(t0) {
  const $ = _c(16);
  const {
    drawNumber,
    product,
    retailerData,
    role
  } = t0;
  const [couponId, currentCouponIndex] = useCouponId();
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const couponIndices = useCouponIndices(t1);
  let t2;
  if ($[2] !== couponId || $[3] !== currentCouponIndex) {
    t2 = {
      couponId,
      couponIndex: currentCouponIndex
    };
    $[2] = couponId;
    $[3] = currentCouponIndex;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const couponType = useCouponType(t2);
  if (couponType === "singlerows") {
    let t3;
    if ($[5] !== drawNumber || $[6] !== product || $[7] !== role) {
      t3 = <SrowCouponOverviewContainer drawNumber={drawNumber} product={product} role={role} />;
      $[5] = drawNumber;
      $[6] = product;
      $[7] = role;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    return t3;
  }
  let t3;
  if ($[9] !== couponIndices || $[10] !== currentCouponIndex || $[11] !== drawNumber || $[12] !== product || $[13] !== retailerData || $[14] !== role) {
    t3 = <CouponsOverview couponIndices={couponIndices} currentCouponIndex={currentCouponIndex} drawNumber={drawNumber} product={product} retailerData={retailerData} role={role} />;
    $[9] = couponIndices;
    $[10] = currentCouponIndex;
    $[11] = drawNumber;
    $[12] = product;
    $[13] = retailerData;
    $[14] = role;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
}